import React from 'react';
import '../styles.css';

const Modals = ({ isOpen, children, className = '' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4 md:p-8 lg:p-16 bg-gray-500 bg-opacity-75 overflow-y-auto z-50">
      <div className={`w-full ${className || 'max-w-3xl'} bg-white rounded-lg shadow-xl overflow-hidden`} style={{ maxHeight: '95vh' }}>
        <div className="p-4 md:p-6 overflow-y-auto" style={{ maxHeight: '95vh' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modals;
